import {
  Space,
  Dropdown,
  message,
  Tag,
  Flex,
  Tooltip,
  Button
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  MenuOutlined,
  HistoryOutlined,
  FieldTimeOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import EmployeesInformationModal from "./component/EmployeesInformationModal";
import LeaveModal from "./component/LeaveModal";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    name: undefined,
    hireDate: undefined,
    employmentStatus: undefined,
    payRate: undefined,
    employmentTitleId: undefined,
    rentCreditId: undefined,
    propertyLiveIn: undefined,
    propertyManages: undefined,
    groupAccess: undefined,
    supervisorId: undefined,
  }

  const [tableHead, setTableHead] = useState(initTableHead);

  const [currentRecord, setCurrentRecord] = useState(null);

 const tableFilterFn = (event, key, type = 'Input') => {
  // 处理 Company 字段
  if (key === 'companyWorkUnderList') {
    const value = event?.target?.value ?? event;
    setTableHead(prev => {
      const newTableHead = {
        ...prev,
        companyWorkUnder: value 
      };
      delete newTableHead.companyWorkUnderList;
      getTableListFn(1, undefined, newTableHead);
      return newTableHead;
    });
  } else {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn});
  }
}

  const [supervisorList, setSupervisorList] = useState([]);
  const [employmentTitleList, setEmploymentTitleList] = useState([]);
  const [employmentTimeAllowanceList, setEmploymentTimeAllowanceList] = useState([]);
  
  const getSupervisorList = async () => {
    const response = await http.get(api.getSupervisorNameDict);
    if (response?.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.accountId,
        label: item.fullName,
      }));
      setSupervisorList(list);
    }
  };

  const getEmploymentTitleList = async () => {
    const response = await http.get(api.employmentTitleDropdown);
    if (response?.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.id,
        label: item.titleName,
      }));
      setEmploymentTitleList(list);
    }
  };

  const getEmploymentTimeAllowanceList = async () => {
    const response = await http.get(api.employeesTimeAllowanceDropdown, {params: {type: 'RENT_CREDIT'}});
    if (response?.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setEmploymentTimeAllowanceList(list);
    }
  };

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Edit") ||
         commonFn.btnAuthorityFlag("EditPropGroup") || 
         commonFn.btnAuthorityFlag("EditProp") || 
         commonFn.btnAuthorityFlag("EditGroup") || 
         commonFn.btnAuthorityFlag("Delete") || 
         commonFn.btnAuthorityFlag("Detail")||
         commonFn.btnAuthorityFlag("AnnualLeave")||
         commonFn.btnAuthorityFlag("SickLeave")) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag("Edit") && {
                key: "Edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              },
              commonFn.btnAuthorityFlag("EditPropGroup") && {
                key: "EditPropGroup",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit Prop & Group</div>,
              },
              commonFn.btnAuthorityFlag("EditProp") && {
                key: "EditProp",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit Prop</div>,
              },
              commonFn.btnAuthorityFlag("EditGroup") && {
                key: "EditGroup",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit Group</div>,
              },
              commonFn.btnAuthorityFlag("Delete") && {
                key: "delete",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Delete</div>,
              },
              commonFn.btnAuthorityFlag("Detail") && {
                key: "detail",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>View Detail</div>,
              },
              //   commonFn.btnAuthorityFlag("AnnualLeave") && {
              //   key: "annualLeave",
              //   icon: <FieldTimeOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
              //   label: <div>Annual Leave</div>,
              // },
              //   commonFn.btnAuthorityFlag("sickLeave") && {
              //   key: "sickLeave",
              //   icon: <FieldTimeOutlined  style={{ color: "#00c0ef", fontSize: "17px" }} />,
              //   label: <div>Sick Leave</div>,
              // },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: 'First Last Name',
      dataIndex: "employeesName",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'name')
    },
    {
      title: 'Hire Date',
      dataIndex: "hireDate",
      titleType: 'DatePicker',
      isArrayDate: true,
      onChange: (e) => tableFilterFn(e, 'hireDate', 'DatePickerFormat'),
    },
    {
      title: 'Employment Status',
      dataIndex: "employmentStatus",
      titleType: 'Select',
      selectOptions: [
        {label: 'Full Time', value: 1},
        {label: 'Part Time', value: 2},
      ],
      render: (text) => {
        const employmentStatusMatch = {
          1: "Full Time",
          2: "Part Time",
        }
        return employmentStatusMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'employmentStatus', 'Select'),
    },
    {
      title: 'Pay Status',
      dataIndex: "payStatus",
      titleType: 'Select',
      selectOptions: [
        {label: 'Salary', value: 1},
        {label: 'Hourly', value: 2},
      ],
      render: (text) => {
        const payStatusMatch = {
          1: "Salary",
          2: "Hourly",
        }
        return payStatusMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'payStatus', 'Select'),
    },
{
  title: 'Company',
  dataIndex: "companyWorkUnderList",
  titleType: 'Input',
  width:200,
  onChange: e => tableFilterFn(e, 'companyWorkUnderList'),
  render: (companyWorkUnderList) => {
    if (!(companyWorkUnderList || [])?.length) {
      return "";
    }
    return (
      <Flex gap="4px 4px" wrap="wrap">
        {companyWorkUnderList.map((item, idx) => (
          <Tooltip key={idx} title={item}>
            <Tag
              color="blue"  
               style={{
                  whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",  
                     display: "inline-block", 
              }}
            >
              {item}  
            </Tag>
          </Tooltip>
        ))}
      </Flex>
    );
  },
},
    {
      title: 'Employment Title',
      dataIndex: "employmentTitleId",
      titleType: 'Select',
      selectOptions: employmentTitleList,
      render: (text, record) => {
        return record?.employmentTitleName || ''
      },
      onChange: e => tableFilterFn(e, 'employmentTitleId', 'Select'),
    },
    {
      title: "Rent Credit",
      dataIndex: "rentCredit",
      titleType: 'Select',
      selectOptions: employmentTimeAllowanceList,
      onChange: e => tableFilterFn(e, 'rentCreditId', 'Select'),

    },
    {
      title: 'Property Live In',
      dataIndex: "propertyLiveIn",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'propertyLiveIn')
    },
    {
      title: 'Property Manages',
      dataIndex: "propList",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'propertyManages'),
      render: (propList) => {
        if (!(propList || [])?.length) {
          return "";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {propList.map((item, idx) => (
              <Tooltip key={idx} title={item.propName}>
                <Tag
                  color="magenta"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.prop}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: 'Group Access',
      dataIndex: "groupList",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'groupAccess'),
      render: (groupList) => {
        if (!(groupList || [])?.length) {
          return "";
        }
        return (
          <Flex gap="4px 0" wrap="wrap">
            {groupList.map((item, idx) => (
              <Tooltip key={idx} title={item.groupName}>
                <Tag
                  color="purple"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.groupCode}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: 'Supervisor',
      dataIndex: "supervisorAccountId",
      titleType: 'Select',
      selectOptions: supervisorList,
      render: (text, record) => {
        return record?.supervisorName || ''
      },
      onChange: e => tableFilterFn(e, 'supervisorId', 'Select'),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.post(api.employeesInformationShow, params);
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  // 新增修改
  const EmployeesInformationRef = useRef(null);
  
  const newFn = () => {
    EmployeesInformationRef.current.openModal({
      type: 'add',
      modalName: 'New Employees Information',
    })
  }

  const customModalRef = useRef(null);
  const leaveModalRef = useRef(null)
  const handleMenuClick = async (item, record) => {
    const { key } = item
    setCurrentRecord(record);
    if(['Edit', 'EditPropGroup', 'EditProp', 'EditGroup'].includes(key)){
      EmployeesInformationRef.current.openModal({
        oldState: record,
        type: key,
        modalName: 'Edit Employees Information',
      })
    }else if(['delete'].includes(key)) {
      customModalRef.current.openModalFn();
    }else if(['detail'].includes(key)) {
      EmployeesInformationRef.current.openModal({
        oldState: record,
        type: 'detail',
        modalName: 'View Employees Information',
      })
    }else if(['annualLeave','sickLeave'].includes(key)) { 
       leaveModalRef.current.openModalFn(key, record.id); 
    }
  }

  const [deleteLoading, setDeleteLoading] = useState(-1);

  const deleteFn = async (deleteAccount) => {
    setDeleteLoading(deleteAccount)
    const response = await http.get(api.employeesInformationDelete, {
      params: {
        id: currentRecord.id,
        deleteAccount
      },
    });
    if (response.code === "1") {
      customModalRef.current?.closeModalFn()
      message.success("Successfully delete.");
      getTableListFn();
    } else {
      commonFn.modalFailedFn(response);
    }
    setDeleteLoading(-1)
  };

  const initColunmsFn = () => {
    setTableList([])
    setColumns(initColumns);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn();
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn()
  }, [refreshKey])

  useEffect(() => {
    getSupervisorList()
    getEmploymentTitleList()
    getEmploymentTimeAllowanceList()
  }, [])

  useEffect(() => {
    if(supervisorList?.length || employmentTitleList?.length || employmentTimeAllowanceList?.length){
      setColumns(initColumns);
    }
  }, [supervisorList, employmentTitleList, employmentTimeAllowanceList]);

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
        </div>
      </CustomTableExtend>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <EmployeesInformationModal
        ref={EmployeesInformationRef}
        submitInitFn={submitInitFn}
      />
      <LeaveModal
        ref={leaveModalRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: "Employees Information",
          onOkFn: deleteFn,
          footer: [
            <Button key="cancel" onClick={customModalRef.current?.closeModalFn} disabled={deleteLoading === 0 || deleteLoading === 1}>
              Cancel
            </Button>,
            <Button key="ok" type="primary" onClick={() => deleteFn(0)} loading={deleteLoading === 0} disabled={deleteLoading === 1}>
              Delete Info
            </Button>,
            <Button key="ok1" type="primary" onClick={() => deleteFn(1)} loading={deleteLoading === 1} disabled={deleteLoading === 0}>
              Delete Info & Account
            </Button>,
          ]
        }}
      />
    </div>
  );
});
export default MainTable;
